"use client";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { useTranslations } from "next-intl";
import { useState } from "react";

export type FAQToggleProps = {
  itemId: string;
  showText?: string;
  hideText?: string;
};

export function FAQToggle({ itemId, showText, hideText }: FAQToggleProps) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  const _showText = showText ?? t("common.show");
  const _hideText = hideText ?? t("common.hide");

  function handleToggleClick() {
    const element = document.getElementById(itemId);
    if (!element) {
      return;
    }

    if (element.style.display === "none") {
      element.style.display = "block";
      setIsOpen(true);
    } else {
      element.style.display = "none";
      setIsOpen(false);
    }
  }

  return (
    <Button variant="outline" onClick={handleToggleClick}>
      <Icon icon={isOpen ? "ChevronUp" : "ChevronDown"} />
      {isOpen ? _hideText : _showText}
    </Button>
  );
}

FAQToggle.displayName = "FAQToggle";
